import styles from "./ErrorComp.module.scss";
export default function ErrorComp({ message }) {
  return (
    <>
      <div className="row">
        <div className={`grid-md-12 ${styles.error_wrapper}`}>
          <span className={`x-small text-red`}>{message}</span>
        </div>
      </div>
    </>
  );
}
